<template>
  <div >
  <section class="schedule">
    <div class="mid-line text-center">
      <h3 >График предварительной записи автобусов</h3>
    </div>
    <div class="schedule__table-wrap">
      <table class="schedule__table">
        <thead>
        <tr>
          <th>Дата</th>
          <th>Время</th>
          <th>Марка, модель автобуса</th>
          <th>Тип автобуса</th>
          <th>Место проведения</th>
          <th>Этап</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="row in rows" :key="row.key">
          <td>{{ row.date }}</td>
          <td>{{ row.time }}</td>
          <td>{{ row.firm }}</td>
          <td>{{ row.typets }}</td>
          <td>{{ row.place }}</td>
          <td>{{ row.stage }}</td>
        </tr>
        <tr v-if="!loading && rows.length === 0">
          <td class="schedule__empty" colspan="6">Записей нет</td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
  </div>
</template>

<script>
import {computed, onMounted, ref} from "vue";
import myStore from "@/store/Store";
import moment from "moment";

export default {
  name: "BusPreSignupSchedule",
  setup() {
    const apiUrl = myStore().apiUrl;
    const loading = ref(false);
    const list = ref([]);

    const getTimestamp = (st) => moment(st, "DD.MM.YYYY HH:mm").unix();
    const normalizeType = (t) => (String(t || "").trim().toUpperCase() || "").replaceAll("M", "М");
    const getDatePart = (dt) => String(dt || "").split(" ")[0] || "";
    const getTimePart = (dt) => String(dt || "").split(" ")[1] || "";

    const rows = computed(() => {
      const now = Date.now() / 1000;
      const seenDatetimes = new Set();

      const prepared = (list.value || [])
        .filter((item) => item && item.datetime)
        .map((item) => {
          const typets = normalizeType(item.typets);
          return {
            ...item,
            typets,
            timestamp: getTimestamp(item.datetime),
          };
        })
        .filter((item) => item.timestamp >= now)
        .filter((item) => String(item.phone || "").trim().length > 0)
        .filter((item) => item.typets === "М2" || item.typets === "М3")
        .sort((a, b) => a.timestamp - b.timestamp);

      const uniqueByDatetime = [];
      for (const item of prepared) {
        const dt = String(item.datetime || "").trim();
        if (!dt) continue;
        if (seenDatetimes.has(dt)) continue;
        seenDatetimes.add(dt);
        uniqueByDatetime.push(item);
      }

      return uniqueByDatetime.map((item) => ({
        key: String(item.datetime || "").trim(),
        date: getDatePart(item.datetime),
        time: getTimePart(item.datetime),
        firm: item.firm || "",
        typets: item.typets || "",
        place: item.pto || "",
        stage: "Первичный",
      }));
    });

    const getList = async () => {
      loading.value = true;
      try {
        const response = await fetch(apiUrl + "/singups/list", {
          method: "GET",
          mode: "cors",
        });
        if (!response.ok) {
          console.error("BusPreSignupSchedule list failed", response.status, response.statusText);
          list.value = [];
          return;
        }
        list.value = await response.json();
      } catch (e) {
        console.log(e);
        list.value = [];
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      getList();
    });

    return {
      rows,
      loading,
    };
  },
};
</script>

<style scoped>
.schedule {
  padding: 30px 0;
  background: transparent;
}

.schedule__title {
  text-align: center;
  font-weight: 600;
  font-size: 42px;
  line-height: 1.15;
  margin: 0 0 24px 0;
  color: #0b0b0b;
}

.schedule__table-wrap {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 16px;
}

.schedule__table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 0;
  overflow: visible;
  box-shadow: none;
}

.schedule__table thead th {
  background: #4ba82e;
  color: #fff;
  padding: 14px 12px;
  font-size: 14px;
  text-align: center;
}

.schedule__table tbody td {
  padding: 16px 12px;
  font-size: 14px;
  color: #111;
  text-align: center;
  border-top: 1px solid rgba(46, 68, 211, 0.18);
}

.schedule__empty {
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
}

@media (max-width: 768px) {
  .schedule__title {
    font-size: 28px;
  }

  .schedule__table thead th,
  .schedule__table tbody td {
    font-size: 12px;
    padding: 10px 8px;
  }
}
</style>
